import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AppLayout from '../components/layout/AppLayout';

const API = process.env.REACT_APP_API_URL || 'http://localhost:3002';

const styles = {
  welcome: { fontSize: '24px', fontWeight: '700', color: '#111827', marginBottom: '8px' },
  sub: { fontSize: '14px', color: '#6b7280', marginBottom: '32px' },
  cards: {
    display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
    gap: '16px', marginBottom: '32px',
  },
  card: {
    backgroundColor: '#fff', borderRadius: '12px', padding: '24px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #e5e7eb',
    cursor: 'pointer', transition: 'box-shadow 0.15s',
  },
  cardLabel: {
    fontSize: '12px', fontWeight: '600', color: '#6b7280',
    textTransform: 'uppercase', letterSpacing: '0.5px',
  },
  cardValue: { fontSize: '32px', fontWeight: '800', color: '#0052CC', margin: '8px 0 4px' },
  cardSub: { fontSize: '12px', color: '#9ca3af' },
  quickActions: { marginBottom: '24px' },
  quickTitle: { fontSize: '16px', fontWeight: '700', color: '#111827', marginBottom: '16px' },
  actionGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '12px' },
  actionBtn: {
    padding: '16px', backgroundColor: '#fff', borderRadius: '10px',
    border: '1px solid #e5e7eb', cursor: 'pointer', textAlign: 'left',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
  },
  actionIcon: { fontSize: '20px', marginBottom: '8px' },
  actionLabel: { fontSize: '14px', fontWeight: '600', color: '#111827' },
  actionSub: { fontSize: '12px', color: '#6b7280', marginTop: '2px' },
};

const quickActions = [
  { icon: '🎙', label: 'Start Practice', sub: 'Practice a real conversation', path: '/practice' },
  { icon: '◈', label: 'New Agent', sub: 'Build a conversational agent', path: '/agents/new' },
  { icon: '◉', label: 'New Scenario', sub: 'Design a simulation scenario', path: '/scenarios/new' },
  { icon: '▶', label: 'Run Simulation', sub: 'Start from a scenario', path: '/scenarios' },
];

export default function Dashboard() {
  const { currentUser, userProfile } = useAuth();
  const navigate = useNavigate();
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    if (currentUser) fetchOverview();
  }, [currentUser]);

  async function fetchOverview() {
    try {
      const res = await fetch(`${API}/api/analytics/overview?owner_id=${currentUser.uid}`);
      const data = await res.json();
      setOverview(data);
    } catch { }
  }

  const statCards = [
    { label: 'Agents', value: overview?.total_agents ?? '—', sub: 'configured agents', path: '/agents' },
    { label: 'Scenarios', value: overview?.total_scenarios ?? '—', sub: 'built scenarios', path: '/scenarios' },
    { label: 'Simulations', value: overview?.total_simulations ?? '—', sub: 'total runs', path: '/simulations' },
    { label: 'Avg Score', value: overview?.avg_overall_score ?? '—', sub: 'evaluation score /100', path: '/analytics' },
  ];

  return (
    <AppLayout>
      <div style={styles.welcome}>
        Welcome back, {userProfile?.displayName || 'Researcher'}
      </div>
      <div style={styles.sub}>
        {userProfile?.organization && `${userProfile.organization} · `}
        V2VLab Conversational Simulation Platform
      </div>

      {/* Stat cards */}
      <div style={styles.cards}>
        {statCards.map(card => (
          <div key={card.label} style={styles.card} onClick={() => navigate(card.path)}>
            <div style={styles.cardLabel}>{card.label}</div>
            <div style={styles.cardValue}>{card.value}</div>
            <div style={styles.cardSub}>{card.sub}</div>
          </div>
        ))}
      </div>

      {/* Quick actions */}
      <div style={styles.quickActions}>
        <div style={styles.quickTitle}>Quick Actions</div>
        <div style={styles.actionGrid}>
          {quickActions.map(action => (
            <div key={action.path} style={styles.actionBtn} onClick={() => navigate(action.path)}>
              <div style={styles.actionIcon}>{action.icon}</div>
              <div style={styles.actionLabel}>{action.label}</div>
              <div style={styles.actionSub}>{action.sub}</div>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  );
}
